var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "range-datepicker",
      staticClass: "emd-date-picker _inline",
      attrs: { id: "range-datepicker" },
      on: {
        click: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "eu-display_flex eu-zindex_4 eu-position_relative eu-align-items_end",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "emd-form-group eu-no-padding eu-mr_2 eu-basis_12 eu-shrink_1",
              attrs: { "data-children-count": "1" },
            },
            [
              _c(
                "label",
                {
                  staticClass:
                    "emd-text _type_label _color_primary _size_tiniest",
                  attrs: { for: "since" },
                },
                [_vm._v(_vm._s(_vm.$t("since")))]
              ),
              _c("input-date", {
                ref: "range-start",
                staticClass: "_size_small",
                attrs: {
                  "aria-autocomplete": "off",
                  locale: _vm.locale,
                  value: _vm.startModel,
                  id: "range-start",
                  name: "start",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "emd-form-group eu-no-padding eu-basis_12 eu-shrink_1",
              attrs: { "data-children-count": "1" },
            },
            [
              _c(
                "label",
                {
                  staticClass:
                    "emd-text _type_label _color_primary _size_tiniest",
                  attrs: { for: "until" },
                },
                [_vm._v(_vm._s(_vm.$t("until")))]
              ),
              _c("input-date", {
                ref: "range-end",
                staticClass: "_size_small",
                attrs: {
                  "aria-autocomplete": "off",
                  locale: _vm.locale,
                  value: _vm.endModel,
                  id: "range-end",
                  name: "end",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "eu-ml_2" }, [
            _c(
              "button",
              {
                staticClass: "emd-btn _size_small _color_primary",
                attrs: { type: "submit" },
                on: { click: _vm.submit },
              },
              [_c("i", { staticClass: "uil uil-search" })]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }